import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {useLayoutEffect, useState} from 'react';
import {useGlobals} from '../../../providers/globalPropsProvider';
import {AddToCartButtonDataHook} from '../AddToCartButton/AddToCartButton';

export function useStickyVisibility() {
  const {addToCartState, isEditorMode} = useGlobals();
  const [isInViewPort, setIsInViewPort] = useState(true);
  const [hasEnteredViewport, setHasEnteredViewport] = useState(false);

  useLayoutEffect(() => {
    const button = document.querySelector(`[data-hook="${AddToCartButtonDataHook.Button}"]`);

    if (!button) {
      setIsInViewPort(false);
      setHasEnteredViewport(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInViewPort(entry.isIntersecting);
        if (entry.isIntersecting) {
          setHasEnteredViewport(true);
        }
      },
      {threshold: 0.1}
    );
    observer.observe(button);
    return () => observer.disconnect();
  }, []);

  const isAddToCartClickable = [AddToCartState.ENABLED, AddToCartState.PRE_ORDER].includes(addToCartState);
  const viewportGuardMet = isEditorMode || hasEnteredViewport;

  return !isInViewPort && isAddToCartClickable && viewportGuardMet;
}
